import*as t from"react";const e=t.createContext({});export{e as IconsContext};
